module.exports = __webpack_public_path__ + "static/media/instluminarias3.57dac8bd.webp";